<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     style="background-image: url('/storage/banner/60e3e3b545c85.png')">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100" ref="form" data-url="/user/password-reset" action="store">
                        <div class="text-center mb-4">
                            <img src="/storage/logo/logo.svg" alt=""
                                 class="img-fluid logo">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mt-3">
                                <label v-if="this.lang == 'en'" class="text-center d-block">Enter your e-mail address</label>
                                <label v-else-if="this.lang == 'sk'" class="text-center d-block">Pre zmenu hesla zadajte svoju e-mailovú adresu</label>
                                <label v-else class="text-center d-block">{{ $t('enter_email_to_reset_password') }}</label>
                            </div>
                        </div>
                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <label for="reset_email">E-mail address</label>
                                <app-input type="email"
                                           v-model="reset.email"
                                           placeholder="Enter your e-mail"
                                           :required="true"
                                />
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <label for="reset_email">Emailová adresa</label>
                                <app-input type="email"
                                           v-model="reset.email"
                                           placeholder="Zadajte svoj e-mail"
                                           :required="true"
                                />
                            </div>
                            <div v-else class="form-group col-12">
                                <label for="reset_email">{{ $t('email') }}</label>
                                <app-input type="email"
                                           v-model="reset.email"
                                           :placeholder="$t('enter_your_email')"
                                           :required="true"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               label="Reset password"
                                               :class="{'disabled': userId}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               label="Zmeniť heslo"
                                               :class="{'disabled': userId}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                            <div v-else class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               :label="$t('reset_password')"
                                               :class="{'disabled': userId}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') }} Onboardio
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";

    export default {
        name: "PasswordReset",
        props: {
            userId: {}
        },
        mixins: [AuthMixin, ThemeMixin],
        data() {
          return {
              reset: {},
              lang: 'cs',
          }
        },
        mounted() {
            let loginLang = "";
            if(this.getCookie("loginLang")){
                loginLang = this.getCookie("loginLang");
                this.changeLang(loginLang);
            }
        },
        methods: {
            submit() {
                this.save(this.reset);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            changeLang(lang){
                this.lang = lang;
                this.checkTenancy();
                document.cookie = "loginLang="+lang+";path=/";
            },
            getCookie(cname) {
              let name = cname + "=";
              let ca = document.cookie.split(';');
              for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return "";
            }
        }
    }
</script>
